import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';

function Home () {
    const [menuData, setMenuData] = useState()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const menus = useSelector(state => state.navbar.menus)
    const message = useSelector(state => state.navbar.message)
    const {username,mobile,email} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
    return (
        <>
            <div className='row justify-content-center align-items-center'>

                <div className='col-6 col-md-4 mb-3'>
                    <Link to={'/dashboard/documents'} className='card btn fw-bolder p-5 text-center border-0 rounded'>                     
                        <span>
                            <i className="fa-regular fa-map fa-xl"></i>
                        </span>
                        <small>مدیریت</small>
                    </Link>
                </div>
                <div className='col-6 col-md-4 mb-3'>
                    <Link to={'/dashboard/document/create'} className='card btn fw-bolder p-5 text-center border-0 rounded'>
                        <span>
                            <i className="fa-regular fa-keyboard fa-xl"></i>
                        </span>
                        <small>ثبت سند</small>
                    </Link>
                </div>
                <div className='col-6 col-md-4 mb-3'>
                    <Link to={'/dashboard/document/transfer'} className='card btn fw-bolder p-5 text-center border-0 rounded'>
                        <span>
                            <i className="fa-regular fa-envelope fa-xl"></i>
                        </span>
                        <small>انتقال</small>
                    </Link>
                </div>
                <div className='col-6 col-md-4 mb-3'>
                    <Link to={'/dashboard/document/request/create'} className='card btn fw-bolder p-5 text-center border-0 rounded'>
                        <span>
                            <i className="fa-regular fa-user fa-xl"></i>
                        </span>
                        <small>نوبت دهی</small>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Home;